import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import ProfilePage from '../profilePage/TeacherPage';
import { TitleBar } from '../common/theme';

const TeacherProfile = ({pageState}) => {
const {innerState, database, request} = pageState;

return (
(!innerState.showTeacherProfileComp) ?<></>:<> 
    <TitleBar>
        <Col  style={{textAlign: 'left', color: 'white' }} xs='2'><h3>Edit Profile</h3></Col>
        <Col  style={{textAlign: 'left', color: 'white' }} xs='10'>
        <span className={'pull-right'}>
            <Button variant="danger" onClick={()=>innerState.showStudentScreen({...innerState.showStudentTableComp, display:true})}>Close</Button>
        </span>    
        </Col>
    </TitleBar>
    <Row><Col xs={{ span: 10, offset: 1 }}> <br/> <ProfilePage pageState={{database, request, classID:innerState.showStudentTableComp.classInfo.ClassID}}/> </Col></Row>;
</>);
};
TeacherProfile.propTypes = {
    pageState: PropTypes.object
};

export default TeacherProfile;